// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__Py5P4","back":"styles_back__UY2gm","footerNavigation":"styles_footerNavigation__9eTjw"};